import { baseUrl } from "../../../boot/index";
import axios from "axios";

// delete employees 
export const deleteEmployee = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/hrm/app/v1/delete-employees/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// add employees
export const addEmployee = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/hrm/app/v1/create-employees`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log({ error })
      throw error
    }
  }

// update employe
export const updateEmployee = async (data) => {
  console.log({ data })
  const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/hrm/app/v1/update-employees/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// Get Company by ID
export const getEmployeesById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/hrm/app/v1/get-employees/${id}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}



// total count Attendance
export const countEmployees = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/hrm/app/v1/count-employees`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}